export default __webpack_public_path__ + "static/media/riverwalk_planking.ebc0af54.jpg";